import React, { useContext, useState } from "react";
import { toCurrency } from "../../../../utilities/FormatHelpers";
import { AccountContext } from "../../AccountContext";
import { useAsyncEffect } from "@app/hooks";

export default function LedgerAllocations(props: { transactionId: string }) {
    const { accountId, ledgerService } = useContext(AccountContext);
    const { transactionId } = props;
    const [ledgerAllocations, setLedgerAllocations] = useState({ loaded: false } as any);

    useAsyncEffect(async () => {
        const ledgerAllocationsResponse = await ledgerService.getLedgerAllocations(accountId, transactionId);

        if (!ledgerAllocationsResponse) {
            setLedgerAllocations({ loaded: false });
        } else {
            setLedgerAllocations({ loaded: true, ...ledgerAllocationsResponse })
        }
    }, [transactionId]);

    if (ledgerAllocations?.loaded && ledgerAllocations?.subledgers) {
        return (
            <div className="ui list">
                {ledgerAllocations.subledgers.map(subledger =>
                    <div className="item" key={subledger.subledgerId}>
                        <div className="ui label" key={subledger.subledgerId}>
                            {subledger.subledgerId.replace(/(.{7})..+/, "$1…")}
                            {subledger.allocations.map(allocation =>
                                <div className="detail" key={`${subledger.subledgerId}-${allocation.splitType}-${allocation.balanceType}`}>
                                    {allocation.splitType} {allocation.balanceType}: {toCurrency(allocation.amount.value)}
                                </div>)}
                        </div>
                    </div>)
                }
            </div>
        )
    }
}

